import { render, staticRenderFns } from "./ServiceTitle.vue?vue&type=template&id=82a16e1a&scoped=true&"
import script from "./ServiceTitle.vue?vue&type=script&lang=js&"
export * from "./ServiceTitle.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTitle.vue?vue&type=style&index=0&id=82a16e1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a16e1a",
  null
  
)

export default component.exports